module.exports = __webpack_public_path__ + "img/2heart-02.4dc012d9.svg";